<template>
  <div>
  </div>
</template>
<script>
import { Dialog } from 'vant';
import isAppBack from '@/mixin/isAppBack'
import ProductAPI from '@/services/h5/product'
import API from '@/services/h5/common'

export default {
  mixins: [isAppBack],
  data() {
    return {
      productId: this.$route.query.productId,
      userId: this.$route.query.userId
    }
  },
  mounted() {
    ProductAPI.getGyAgent()
      .then(res => {
        let agent = res.data.data
        Dialog.confirm({
          message:
            '即将使用' + agent.agentName + '的代理人账号' + agent.gyAgentCode + '进行登录',
        })
        .then(() => {
          let params = {
            productId: this.productId,
            userId: this.userId
          }
          API.getonlineProduct(params)
            .then(res => {
              window.location.href = res.data.data.productUrl
            })
            .catch(() => {
              this.judgeAppBack()
            })
        })
        .catch(() => {
          this.judgeAppBack()
        })
      })
      .catch(err => {
        Dialog.alert({
          message: err.data.data,
        }).then(() => {
          this.judgeAppBack()
        });
      })

  },
}
</script>
